module.exports = __webpack_public_path__ + "adb88109e8983be3bcd5e18c06108c4a.svg";